import { ReactNode } from 'react';

import { RewardPoolTicket } from '@store:web/components/entities/rewardPool';
import { CopyButton } from '@ui/uikit/components/common/CopyButton';

export type TicketListItemType = {
  code: string;
  isWinner: boolean;
  showWinText?: boolean;
  extraBottom?: ReactNode;
};

type Props = TicketListItemType;

export const TicketsListItem = ({ code, isWinner, showWinText = true, extraBottom }: Props) => {
  return (
    <div>
      <div className="flex justify-between gap-2 group items-center">
        <div className="h-10 flex items-center gap-2 max-w-full overflow-hidden">
          <RewardPoolTicket code={code} isWinner={isWinner} />
          {isWinner && showWinText && (
            <span className="text-base-text-orange text-caption-sm-a">Win!</span>
          )}
        </div>

        <CopyButton
          value={code}
          className="
          p-2 max-sm-msq:opacity-100 opacity-0 group-hover:opacity-100 transition-opacity
          msq-btn msq-btn-icon-md msq-btn-md msq-btn-ghost h-8
        "
        />
      </div>
      {extraBottom}
    </div>
  );
};
